import styled from "styled-components";
import { useInit, useWatcher } from "../logic";
import Fields from "./fields";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex: 1;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
  }
`;

const Content = styled.div`
  & {
    display: grid;
    grid-template-columns: 1fr 260px;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
    column-gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);

    & > * {
      grid-column: span 1;

      &:last-child,
      &:first-child {
        grid-column: span 2;
      }
    }
  }
`;

const Single = styled.div`
  & > * {
    max-width: 260px;
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxSM} {
    ${Content} {
      grid-template-columns: 1fr;
      gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
      & > * {
        grid-column: span 1;
        width: 100%;
        & > * {
          max-width: 100%;
        }
      }
    }
  }
`;

function Form() {
  useInit();
  useWatcher();

  return (
    <Wrapper>
      <Content>
        <Fields.Sender />
        <Fields.Recipient />
        <Single>
          <Fields.Chain />
        </Single>
        <Fields.Streams />
      </Content>
    </Wrapper>
  );
}

export default Form;
